// extracted by mini-css-extract-plugin
module.exports = {"index":"ticxBBn","cover":"_1RVtu46","categoryBackground":"iiclNib _2t5guGG","articlesHeader":"_1EdhLc1 _2znJ6SM"};